const layout = {
	"nav-items": {
		dashboard: "Dashboard",
		tasks: "Tasks",
		messages: "Messages",
		hours: "Hour validation",
		"my-hours": "Hour registration",
		studentpool: "Connections",
		talents: "Professionals",
		payments: "Payments",
		agreements: "Agreements",
		"my-profile": "My Profile",
		signout: "Sign Out",
		"search-tasks": "Search Tasks",
		"my-tasks": "My Tasks",
		"my-offers": "My Offers",
		"my-network": "My Network",
		"my-payments": "My Payments",
		links: "Links",
		faq: "FAQ",
		contact: "Contact",
		"edit-profile": "Edit Profile",
		settings: "Settings",
		reviews: "Reviews",
		feedback: "Feedback",
	},
	seo: {
		description: "Work where you want, when you want & start earning.",
	},
};

export default layout;
